export const extensionRoutes = [  {
    path: 'extensions/contact',
    loadChildren: () => import('./extensions/c6e660947bba2eaf69fac4c48432effafaea489dff4d0d938ab67c6ae3b2f820/contact-ui-lazy.module').then(m => m.ContactUIModule),
  },
  {
    path: 'extensions/blogs',
    loadChildren: () => import('./extensions/e45097dda8807f1b304131aee85449a7bce3d4dd8df89cb4b46e77c499e0dc2c/blog.module').then(m => m.BlogModule),
  }];
